import React, { useEffect, useState } from "react";
import { Camera, Cloud, Gauge, Sprout } from "lucide-react";
import { PageShell, PageHero, PageSection } from "../components/PageShell";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { contentService } from "../services/contentService";

export default function FutureUpdates() {
  const [items, setItems] = useState([]);
  const [nearTermFocus, setNearTermFocus] = useState("");

  useEffect(() => {
    const iconMap = { Camera, Cloud, Gauge, Sprout };
    let mounted = true;
    (async () => {
      try {
        const items = await contentService.listFutureItems();
        const meta = await contentService.getFutureMeta();
        if (!mounted) return;
        setItems(
          (items || []).map((it) => ({
            ...it,
            icon: iconMap[it.icon] || Cloud,
          }))
        );
        if (meta?.nearTermFocus) setNearTermFocus(meta.nearTermFocus);
      } catch (_e) {}
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <PageShell>
      <PageHero
        eyebrow="Roadmap"
        title="Not in the app"
        highlight="yet."
        description="Schedules and moisture rules are already on the device page. The items below are still missing."
      />

      <PageSection variant="content">
        <div className="mx-auto max-w-6xl grid gap-6">
          <div className="grid md:grid-cols-2 gap-6">
            {items.map((it) => {
              const Icon = it.icon;
              return (
                <Card key={it.title} className="shadow-soft">
                  <CardHeader>
                    <CardTitle className="flex items-center gap-3">
                      <span className="h-10 w-10 rounded-2xl bg-secondary flex items-center justify-center">
                        <Icon className="h-5 w-5 text-primary" />
                      </span>
                      {it.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="text-sm text-muted-foreground leading-relaxed">
                    {it.desc}
                  </CardContent>
                </Card>
              );
            })}
          </div>
          {!items.length ? <div className="text-sm text-muted-foreground">No roadmap items available in database.</div> : null}

          <div className="rounded-3xl border border-border bg-card p-8 shadow-soft">
            <div className="font-display text-2xl">Near-term focus</div>
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed max-w-3xl">
              {nearTermFocus}
            </p>
          </div>
        </div>
      </PageSection>
    </PageShell>
  );
}

